import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getSingleProductbystatus } from "../../../actions/singleProductAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllLocation } from "../../../actions/warehouseAction";
import ActiveRendertableSEO from "./ActiveRendertableSEO";
import ExcelldownloadSEO from "./ExcelldownloadSEO";
import { LoadingOutlined } from "@ant-design/icons";
import {
  Skeleton,
  Tabs,
  Row,
  Col,
  AutoComplete,
  Divider,
  TreeSelect,
  Spin,
  Select,
} from "antd";
const { Option } = Select;

const { TabPane } = Tabs;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const ProductList = ({
  getSingleProductbystatus,
  List,
  updatelist,
  setUpdatelist,
  setselectedproduct,
  totalitems,
  getAllCategory,
  categoryList,
  Location,
}) => {
  const [data, setdata] = useState(false);
  const [products, setproducts] = useState(false);
  const [report, setReport] = useState([]);
  const loading = useRef(true);
  const pageno = useRef(1);
  const page_size = useRef(10);
  const keytab = useRef(true);
  const keyward = useRef("");
  const searchCategory = useRef("");
  const searchLocation = useRef("");
  const [reload, setreload] = useState(false);

  const onChange = (event) => {
    if (event.keyCode == 13) {
      pageno.current = 1;
      keyward.current = event.target.value;
      setreload(true);
    }
  };

  function callback(key) {
    console.log(key);
    pageno.current = 1;
    if (key == 1) {
      keytab.current = true;
    } else {
      keytab.current = false;
    }
    setreload(true);
  }

  useEffect(() => {
    getAllCategory();
    getAllLocation();
    getSingleProductbystatus(
      keytab.current,
      keyward.current,
      searchCategory.current,
      "",
      "",
      pageno.current,
      page_size.current,
      true
      // searchLocation.current
    ).then((result) => {
      setproducts(result);
      let count = 1;
      result.results.map((item) => {
        // console.log(item);
        item?.variations.map((variation) => {
          let variations = {
            sl: parseInt(count),
            ProductName: item.name,
            ProductDescription: item.Short_description,
            StyleCode: item.title,
            Barcode: variation.barcode,
            Size: variation.size,
            Color: variation.color,
            Quantity: variation.quantity,
            MRP: variation.selling_price,
            ProductID: variation.id,
            ProductImage: variation?.image[0]?.photo,
            ProductImage1: variation?.image[1]?.photo,
            ProductImage2: variation?.image[2]?.photo,
            ProductImage3: variation?.image[3]?.photo,
            ColorID: variation.Color,
            url: item.url,
          };
          count = parseInt(count) + 1;
          setReport((report) => [...report, variations]);
        });
      });
      // console.log(report);
      setUpdatelist(true);
      setdata(true);
      setreload(false);
    });
  }, [reload]);

  const rendertable = () => {
    if (reload) {
      return (
        <>
          <span style={{ marginTop: "30px" }}>
            <Spin indicator={antIcon} /> loading
          </span>
        </>
      );
    }
  };

  if (data) {
    return (
      <>
        <Row>
          <Col span={8}>
            <h3>Enter product title for instant Search</h3>
            <AutoComplete
              placeholder="input search text"
              onKeyUp={onChange}
              style={{ width: "100%" }}
            />
          </Col>
          <Col span={6} >
            <h3>Category</h3>

            <TreeSelect
              style={{ width: "100%" }}
              treeData={categoryList}
              onChange={(value) => {
                pageno.current = 1;
                searchCategory.current = value;
                setreload(true);
              }}
            />
          </Col>
          <Col span={5}>
            <h3>Excel data</h3>
            <ExcelldownloadSEO data={report} />
          </Col>
        </Row>
        <Divider />
        <Spin spinning={reload}>
          <ActiveRendertableSEO
            List={products.results}
            setUpdatelist={setUpdatelist}
            setselectedproduct={setselectedproduct}
            pageno={pageno}
            page_size={page_size}
            totalitems={totalitems}
            setreload={setreload}
          />
        </Spin>
      </>
    );
  } else {
    return (
      <>
        <Skeleton active />
        <Skeleton active />
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    List: state.singleProduct.sinleproductlist.results,
    totalitems: state.singleProduct.sinleproductlist.count,
    categoryList: state.category.categorylist,
    Location: state.warehouse.locationlist,
  };
};

export default connect(mapStateToProps, {
  getSingleProductbystatus,
  getAllCategory,
})(ProductList);
